/** UserPermissions: управление правами, назначение резидентом */
export const ADMIN_PERMISSION_USER_PERMISSIONS = 2;

/** Admin.Banners */
export const ADMIN_PERMISSION_BANNERS = 3;

/** Admin.Hobbies */
export const ADMIN_PERMISSION_HOBBIES = 4;

/** Admin.FieldActivities — сферы деятельности */
export const ADMIN_PERMISSION_FIELD_ACTIVITIES = 5;

/** Admin.Countries */
export const ADMIN_PERMISSION_COUNTRIES = 6;

/** Admin.Competencies */
export const ADMIN_PERMISSION_COMPETENCIES = 7;

/** Admin.Cities */
export const ADMIN_PERMISSION_CITIES = 8;

/** Admin.Joining — запросы на вступление */
export const ADMIN_PERMISSION_JOIN_REQUESTS = 9;

/** Admin.News */
export const ADMIN_PERMISSION_NEWS = 11;

/** Admin.Events */
export const ADMIN_PERMISSION_EVENTS = 12;

/** Admin.Communities — резиденты и пользователи сообщества */
export const ADMIN_PERMISSION_COMMUNITIES = 13;

/** Admin.Subscriptions */
export const ADMIN_PERMISSION_SUBSCRIPTION_PLANS = 15;

/** Блокировка/разблокировка пользователей в управлении сообществом */
export const ADMIN_PERMISSION_BLOCK_UNBLOCK_USERS = 16;

/** Admin.RaplRequests */
export const ADMIN_PERMISSION_RAPL_REQUESTS = 17;

/** Admin.Connect */
export const ADMIN_PERMISSION_RAPL_CONNECT = 18;

/** Admin.Benefits */
export const ADMIN_PERMISSION_BENEFITS = 20;

/** Admin.Investments */
export const ADMIN_PERMISSION_INVESTMENTS = 21;

/** Admin.Clubs — справочник клубов */
export const ADMIN_PERMISSION_CLUBS = 22;
